/**
 * Lista canônica de fotos exigidas numa vistoria, por tipo de veículo.
 *
 * Vive aqui, e não dentro da tela de captura (at-24), porque três telas precisam
 * da mesma verdade: a captura (para saber o que capturar e com que legenda), o
 * painel e o laudo (para dizer quantas faltam e travar a finalização). Antes o
 * total estava duplicado em código, e duplicata de regra é divergência com data
 * marcada.
 *
 * ⚠️ Estas legendas são **queimadas na imagem** no momento da captura e viram o
 * `caption` do metadado — que vai ao laudo e ao SGA. Alterar um texto aqui NÃO
 * renomeia o que já foi capturado; fotos antigas seguem com o texto antigo.
 *
 * Limitação conhecida: o backend não conhece esta lista, então a validação de
 * completude é só do lado do cliente. Uma chamada direta à API ainda geraria laudo
 * incompleto. Mover isto para o banco/backend é frente própria (mesma família do
 * `planosMap` hardcoded, item 6 do backlog).
 */

export const legendasCarro = [
  'Frente Capô Fechado (com placa)',
  'Frente + Lateral Direita (com placa)',
  'Frente + Lateral Esquerda (com placa)',
  'Frente Capô Aberto (com placa)',
  'Motor Lado Direito Completo',
  'Motor Lado Esquerdo Completo',
  'Bateria do Veículo',
  'Traseira Mala Fechada',
  'Traseira + Lateral Direita (com placa)',
  'Traseira + Lateral Esquerda (com placa)',
  'Traseira Mala Aberta',
  'Itens de Segurança (Macaco, Chave de Roda, Triângulo)',
  'Estepe do Veículo',
  'Medida do Estepe',
  'Pneu Traseiro Direito',
  'Pneu Traseiro Esquerdo',
  'Pneu Dianteiro Lado Direito (direção virada)',
  'Pneu Dianteiro Lado Esquerdo (direção virada)',
  'Medida do Pneu',
  'Porta do Carona Aberta + Câmbio e Volante',
  'Porta do Motorista Aberta + Câmbio e Volante',
  'Interior do Veículo com Painel Completo',
  'Painel + Giros (com motor ligado)',
  'Chassis (lataria)',
  'Chaves do Veículo',
  'Vista Frontal Teto',
  'Vista Traseira Teto',
  'Porta Traseira Direita (aberta) + Banco',
  'Porta Traseira Esquerda (aberta) + Banco',
];

export const legendasMoto = [
  'Frontal Completa',
  'Frontal + Lateral Direita',
  'Frontal + Lateral Esquerda',
  'Traseira Total',
  'Traseira + Lateral Direita',
  'Traseira + Lateral Esquerda',
  'Lateral Direita',
  'Lateral Esquerdo',
  'Painel Ligado',
  'Km Atual',
  'Chassis',
  'Emplacamento',
  'Pneu Dianteiro (Marca e Banda de Rodagem)',
  'Pneu Dianteiro (Medida)',
  'Pneu Traseiro (Marca e Banda de Rodagem)',
  'Pneu Traseiro (Medida)',
  'Chaves do Veículo',
];

/** O tipo vem da descrição do SgaTipoVeiculo — só "MOTO" no texto distingue. */
export function ehMoto(tipoVeiculo?: string | null): boolean {
  return (tipoVeiculo ?? '').toUpperCase().includes('MOTO');
}

export function legendasPorTipo(tipoVeiculo?: string | null): string[] {
  return ehMoto(tipoVeiculo) ? legendasMoto : legendasCarro;
}

export function totalFotosEsperado(tipoVeiculo?: string | null): number {
  return legendasPorTipo(tipoVeiculo).length;
}
